import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

interface InboxActiveDateRangeResponse {
  firstDate: string | null
  lastDate: string | null
}

export const useGetInboxActiveDateRangeQuery = (pageId?: string) => {
  return useQuery({
    enabled: !!pageId,
    queryFn: async (): Promise<InboxActiveDateRangeResponse> => {
      const response = await analyticsApi().get(
        `/v1_private/inbox-analysis/${pageId}/activeDateRange`
      )
      return response.data
    },
    queryKey: [QueryKey.GET_INBOX_ACTIVE_DATE_RANGE, pageId],
  })
}
